;(function () {
	/**
	 * Initialize Swiper instances for image-text-slider sections.
	 * Guards against double-initialization and cleans up on section unload in the theme editor.
	 */
	const initImageTextSliders = () => {
		document.querySelectorAll('.image-text-slider').forEach((slider) => {
			const swiperEl = slider.querySelector('.swiper')
			if (!swiperEl || swiperEl.dataset.swiperInitialized === 'true') return

			const navPrev = slider.querySelector('.swiper-button-prev')
			const navNext = slider.querySelector('.swiper-button-next')

			const swiper = new Swiper(swiperEl, {
				slidesPerView: 4,
				spaceBetween: 0,
				keyboard: true,
				watchOverflow: true,
				observer: true,
				observeParents: true,
				navigation:
					navPrev && navNext
						? {
								nextEl: navNext,
								prevEl: navPrev,
						  }
						: {},
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					769: {
						slidesPerView: 2,
					},
					1025: {
						slidesPerView: 4,
					},
				},
				on: {
					init() {
						swiperEl.dataset.swiperInitialized = 'true'
					},
					destroy() {
						delete swiperEl.dataset.swiperInitialized
					},
				},
			})

			swiperEl.swiperInstance = swiper
		})
	}

	const destroyImageTextSliders = (container = document) => {
		container.querySelectorAll('.image-text-slider .swiper').forEach((swiperEl) => {
			if (swiperEl.swiperInstance) {
				swiperEl.swiperInstance.destroy(true, true)
				delete swiperEl.swiperInstance
			}
			delete swiperEl.dataset.swiperInitialized
		})
	}

	document.addEventListener('DOMContentLoaded', () => {
		initImageTextSliders()
	})

	document.addEventListener('shopify:section:load', (event) => {
		initImageTextSliders()
	})

	document.addEventListener('shopify:section:unload', (event) => {
		if (event && event.target) {
			destroyImageTextSliders(event.target)
		} else {
			destroyImageTextSliders()
		}
	})
})()
